import { jsx } from "react/jsx-runtime";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { validateTidalLicense } from "../../base/index.js";
function InfoOutlined(props) {
  return /* @__PURE__ */ jsx(
    InfoOutlinedIcon,
    {
      "data-testid": "InfoOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "InfoOutlined",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
InfoOutlined.tidalIconMeta = {
  categories: "cancel,informative",
  name: "InfoOutlined"
};
validateTidalLicense();
export {
  InfoOutlined
};
//# sourceMappingURL=InfoOutlined.js.map
